function SvgRepeat({ color = "#FFC55A", width = 20, height = 20, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#svg_repeat_icon)">
        <path
          d="M14.1667 0.832031L17.5 4.16536M17.5 4.16536L14.1667 7.4987M17.5 4.16536L5.83333 4.16536C4.94928 4.16536 4.10143 4.51655 3.47631 5.14167C2.85119 5.7668 2.5 6.61464 2.5 7.4987V9.16536M5.83333 19.1654L2.5 15.832M2.5 15.832L5.83333 12.4987M2.5 15.832L14.1667 15.832C15.0507 15.832 15.8986 15.4808 16.5237 14.8557C17.1488 14.2306 17.5 13.3828 17.5 12.4987V10.832"
          stroke={color || color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="svg_repeat_icon">
          <rect width={width} height={height} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgRepeat;
